import { createDuck, createEntityCollection } from '@/utils'
import { getDetailData, updateLikeStatus } from '@/services/api/detail'
import { PRODUCT_STATUS_MAP, SHOP_ID, VIDEO_STATUS } from '@/utils/const'
import { getPaymentPreInfo, isObject } from '@/utils/utils'
import { addCart, getRecommend } from '@/services/api/common'
import { duck as commonDuck } from './common'
import { Toast } from 'antd-mobile-v2'

/** @type {detail.DetailState} */
export const DEFAULT_STATUS = {
  status: 0,
  bannerList: [],
  bannerEntites: {},
  services: null,
  comment: null,

  creditDeductionActivitySubItemInfo: {},
  recommend: null,
  /**
   * 字段替换之前的 imgList 字段（即不手动提取图片）
   * 商城返回的是富文本，而且大部分是宽度为 100% 的图片
   * 图片本身可能被一个 a 标签包围，点击之后，跳转到 a 标签指定位置
   */
  mDescription: '',
  like: false,
  subItems: [],
  productInfo: {},
  visible: false,
  /**
   * 决定sku弹层的按钮是 确认 || 加入购物车和立即购买(点击规格)
   * '' | 'add-buy'
   */
  showType: '',

  /**
   * 底部按钮点击 加入购物车 还是 立即购买
   * '':还未选择 | 'add':加入购物车 | 'buy':立即购买
   */
  curType: '',
  couponVisible: false,
  selectedSubItem: {},
  recommendList: [],
  tags: [],
  activityInfo: [],
  paymentPreInfo: {},
}
export const duck = createDuck({
  name: 'detailDuck',
  initialState: {},
  actions: {
    initPageData(itemId) {
      return async dispatch => {
        dispatch(duck.fetchData(itemId))
        dispatch(duck.fetchRecommendData(itemId))
      }
    },

    /**
     * 根据itemId 获取商品详情
     * @param {number} itemId
     * @returns
     */
    fetchData(itemId) {
      return async (dispatch, getState) => {
        const { data, error } = await getDetailData(itemId, SHOP_ID)
        if (!error) {
          const { detailDuck } = getState()
          const preData = detailDuck[itemId] || {}
          const {
            banner,
            couponInfo, // 原来的activitys字段
            services,
            comment,
            recommend,
            like,
            subItems,
            mDescription,
            selectedSubItem,
            activityInfo,
            preSellActivityInfo,
            creditDeductionActivitySubItemInfo,
            ...ot
          } = data || {}
          if (
            ot.status === PRODUCT_STATUS_MAP.OFF_LINE ||
            ot.status === PRODUCT_STATUS_MAP.REMOVED
          ) {
            dispatch(
              duck.change({
                [itemId]: {
                  ...preData,
                  status: -1,
                },
              }),
            )
            return
          }

          const b = Array.isArray(banner) ? banner : []
          const _ban = b.map((item, index) => {
            return { ...item, id: index, videoStatus: VIDEO_STATUS.NO_START }
          })
          const col = createEntityCollection(_ban, item => item.id)
          let _tag = []
          if (Array.isArray(activityInfo)) {
            _tag = _tag.concat(
              activityInfo.map(item => {
                return { name: item.title }
              }),
            )
          }
          if (Array.isArray(couponInfo)) {
            _tag = _tag.concat(
              couponInfo.map(item => {
                return { name: item.name }
              }),
            )
          }

          const _selectedSubItem = preData.selectedSubItem || selectedSubItem || {}

          const _paymentPre = getPaymentPreInfo(preSellActivityInfo)

          //定金预售
          let _newSubItems = [...subItems]
          if (_paymentPre.isPaymentPre) {
            //判断当前子商品是否参加了定金预售活活动
            _newSubItems = subItems.map(_item => {
              const { id: _subID } = _item || {}
              if (_paymentPre[_subID]) {
                const { downPaymentAmount, discountAmount, maxCountLimit, soldCount } =
                  _paymentPre[_subID]
                return {
                  ..._item,
                  isPaymentPre: true,
                  stockCount: maxCountLimit - soldCount < 0 ? 0 : maxCountLimit - soldCount,
                  downPaymentAmount,
                  downDiscountAmount: discountAmount,
                }
              }
              return { ..._item }
            })
          }

          dispatch(
            duck.change({
              [itemId]: {
                ...preData,
                status: 1,
                bannerList: col.list,
                bannerEntites: col.entities,
                services: services || {},
                comment: comment || {},
                recommend,
                creditDeductionActivitySubItemInfo: isObject(creditDeductionActivitySubItemInfo)
                  ? creditDeductionActivitySubItemInfo
                  : {},
                mDescription,
                like,
                subItems: _newSubItems,
                tags: _tag,
                productInfo: ot,
                activityInfo: Array.isArray(activityInfo) ? activityInfo : [],
                selectedSubItem: _selectedSubItem,
                paymentPreInfo: {
                  ..._paymentPre,
                },
              },
            }),
          )
        } else {
          Toast.fail(error.message)
          const { detailDuck } = getState()
          dispatch(
            duck.change({
              [itemId]: {
                ...detailDuck[itemId],
                status: 2,
              },
            }),
          )
        }
      }
    },

    resetData(itemId) {
      return dispatch => {
        dispatch(
          duck.change({
            [itemId]: {
              ...DEFAULT_STATUS,
            },
          }),
        )
      }
    },
    /**
     *
     * @param {object} param
     * @param {boolean} param.val
     * @param {number} param.itemId
     * @param {number}[param.shopId ]
     * @returns
     */
    changeLikeStatu(param) {
      //updateLikeStatus

      return async (dispatch, getState) => {
        const { itemId } = param
        if (!itemId) return
        const { detailDuck } = getState()
        const { error } = await updateLikeStatus(param)
        if (!error) {
          Toast.info(param.val ? '收藏成功' : '已取消收藏', 1.5)
          dispatch(
            duck.change({
              [itemId]: {
                ...detailDuck[itemId],
                like: param.val,
              },
            }),
          )
        } else {
          Toast.fail(error.message || '操作失败')
        }
      }
    },

    changeBannerPlayStatus(id, status, itemId) {
      return async (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.merge({
            [itemId]: {
              ...detailDuck[itemId],
              bannerEntites: {
                ...detailDuck[itemId].bannerEntites,
                [id]: {
                  ...detailDuck[itemId].bannerEntites[id],
                  // playing: palying,
                  videoStatus: status,
                },
              },
            },
          }),
        )
      }
    },

    // changeAllBannerStatus() {
    //   return async (dispatch, getState) => {
    //     const {
    //       detailDuck: { bannerList, bannerEntites },
    //     } = getState()
    //     const _new = bannerList.map(item => {
    //       const { videoStatus } = bannerEntites[item]
    //       return {
    //         ...bannerEntites[item],
    //         videoStatus: videoStatus === VIDEO_STATUS.PLAYING ? VIDEO_STATUS.PAUSED : videoStatus,
    //       }
    //     })
    //     dispatch(
    //       duck.change({
    //         bannerEntites: {
    //           ..._new,
    //         },
    //       }),
    //     )
    //   }
    // },

    /**
     * 加入购物车
     * @param {object} data
     * @returns
     */
    addCart(data, itemId) {
      const { id, count } = data
      return async (dispatch, getState) => {
        const { detailDuck } = getState()

        const { error } = await addCart({ subItemId: id, choice: false, count: count })

        if (!error) {
          Toast.info('添加成功，在购物车等你', 2)
        } else {
          Toast.info(error.message || '加入购物失败')
        }
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              selectedSubItem: { ...data },
              visible: false,
              showType: '',
              curType: '',
            },
          }),
        )
        // dispatch(duck.hideSkuModal(itemId))
        //更新购物车数量
        dispatch(commonDuck.fetCartSummaryInfo())
      }
    },

    changeSelectedSubItem(data, itemId) {
      return async (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              selectedSubItem: { ...data },
            },
          }),
        )
      }
    },

    /**
     * 改变红包列表的展示情况
     * @param {*} val
     * @returns
     */
    changeCouponVisible(val, itemId) {
      return (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              couponVisible: val,
            },
          }),
        )
      }
    },

    /**
     * 滚动的导航条显示和隐藏
     * @param {*} val
     * @returns
     */
    // changeFixNavVisible(val) {
    //   return dispatch => {
    //     dispatch(
    //       duck.change({
    //         fixNavVisible: val,
    //       }),
    //     )
    //   }
    // },

    changeShowType(val, itemId) {
      return (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              showType: val,
            },
          }),
        )
      }
    },
    changeCurType(val, itemId) {
      return (dispatch, getState) => {
        const { detailDuck } = getState()

        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              curType: val,
            },
          }),
        )
      }
    },

    showSkuModal(itemId) {
      return (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              visible: true,
            },
          }),
        )
      }
    },
    hideSkuModal(itemId) {
      return (dispatch, getState) => {
        const { detailDuck } = getState()
        dispatch(
          duck.change({
            [itemId]: {
              ...detailDuck[itemId],
              visible: false,
              showType: '',
              curType: '',
            },
          }),
        )
      }
    },

    fetchRecommendData(itemId) {
      return async dispatch => {
        const { error, data } = await getRecommend(SHOP_ID)
        if (!error) {
          dispatch(
            duck.merge({
              [itemId]: {
                recommendList: data,
              },
            }),
          )
        }
      }
    },
  },
})
